import { DateTimePicker } from './date-time-picker';
import TimePicker from './time-picker';

const CustomDateTimePicker = {
    Root: DateTimePicker,
    TimePicker: TimePicker,
    name: 'Custom',
};

export default CustomDateTimePicker;
